export default "__VITE_ASSET__Cux$p46F__"